"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
require("slick-carousel");
class Slider {
    constructor() {
        this.column_slide = document.getElementById("column-slide");
        if (this.column_slide) {
            this.columnSlide();
        }
    }
    columnSlide() {
        const sliderEle = (0, jquery_1.default)("#column-slide");
        sliderEle.slick({
            infinite: false,
            initialSlide: 0,
            slidesToShow: 3,
            adaptiveHeight: false,
            //variableWidth: true,
            centerMode: false,
            centerPadding: "0",
            arrows: true,
            appendArrows: (0, jquery_1.default)("#column-nav"),
            nextArrow: '<div class="slick-next"><svg><use href="#icn-arrow"></use></svg></div>',
            prevArrow: '<div class="slick-prev"><svg><use href="#icn-arrow"></use></svg></div>',
            dots: true,
            appendDots: (0, jquery_1.default)("#column-indicator"),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                        arrows: false,
                        dots: true,
                    },
                },
            ],
        });
    }
}
exports.default = Slider;
new Slider();
